// extracted by mini-css-extract-plugin
module.exports = {"approach":"Approach_approach__1LH7n","section":"Approach_section__3rein","investment":"Approach_investment__1QpO9"};